import api from "@/libs/axios";
import { hasError } from "@/utils/utils";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    jobs: [],
    loading: false,
    pagination: {
      total_row: 1,
      last_page: 1,
    },
  }),

  getters: {
    jobs(state) {
      return state.jobs;
    },
    loading(state) {
      return state.loading;
    },
    pagination(state) {
      return state.pagination;
    },
  },

  mutations: {
    setJobs(state, payload) {
      state.jobs = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },

  actions: {
    async getJobs({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.get(ep.JOBS, { params: { ...payload } });
        if (hasError(res.status)) throw res.status;
        commit("setJobs", res.data.data);
      } catch (err) {
        console.log(err);
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
